import { Button } from "@/components/ui/button";
import { Home, LogOut } from "lucide-react";

interface DashboardHeaderProps {
  onLogout: () => void;
  onNavigateHome: () => void;
}

const DashboardHeader = ({ onLogout, onNavigateHome }: DashboardHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold text-blue-900">Football Drill Dashboard</h1>
        <p className="text-blue-600">Create and manage your football drills</p>
      </div>
      <div className="flex gap-4">
        <Button
          variant="ghost"
          onClick={onNavigateHome}
          className="flex items-center gap-2"
        >
          <Home className="h-4 w-4" />
          Home
        </Button>
        <Button
          variant="ghost"
          onClick={onLogout}
          className="flex items-center gap-2 text-red-600 hover:text-red-700 hover:bg-red-50"
        >
          <LogOut className="h-4 w-4" />
          Logout
        </Button>
      </div>
    </div>
  );
};

export default DashboardHeader;